import React, { useState, useEffect, useRef } from "react";
// import { FaCalendarAlt } from "react-icons/fa";
import {
  FaCalendarAlt,
  FaFilePdf,
  FaFileCsv,
  FaFileExcel,
  FaFileWord,
  FaFileImage,
  FaFileAlt,
} from "react-icons/fa";
import Select from "react-select";
import Swal from "sweetalert2";
import ReactQuill from "react-quill";
import DatePicker from "react-datepicker";
import Switch from "react-switch";

import uploadIcon from "./../../../Assets/icons/uploadicon.svg";
import jobcardIcon from "../../../Assets/icons/JobCardPlusIcon.svg";
import addcomplaiIcon from "../../../Assets/icons/addcomplain.svg";
import downloadIcon from "../../../Assets/icons/download.svg";
import pdfIcon from "../../../Assets/icons/pdfIcon.png";
import axiosInstance from "../../services/api/API";
import searchIcon from "./../../../Assets/icons/searchicon.svg";

import "react-quill/dist/quill.snow.css";
import "./customForm.scss";

const DynamicForm = ({
  formConfig,
  formData,
  setFormData = () => {},
  validationErrors,
  setValidationErrors = () => {},
  showParentDesignation,
  setShowParentDesignation = () => {},
  images,
  buttonOnclick,
  addComplainHandler,
  cities,
  onclickOpenFrom = () => {},
  handledownload,
  exshowroomprice = "",
  setResponseErrorMessage = () => {},
  isComplaint,
  apiCall,
  apiCallforKilometer,
  cityOptions,
  setCityOptions,
  validateOnMount = false,
}) => {
  const [fileNames, setFileNames] = useState({});
  const [pincode, setPincode] = useState("");
  const [pincodeData, setPincodeData] = useState([]);

  // const [cityOptions, setCityOptions] = useState([]);

  const token = localStorage.getItem("authToken");
  const datePickerRefs = useRef({});

  useEffect(() => {
    if (pincode.length === 6 || formData?.pincode?.length === 6) {
      const fetchPincodeData = async () => {
        try {
          const response = await axiosInstance.post(
            "/pincodestatecity/getbypincode",
            {
              pincode: pincode,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            },
          );

          if (response.status === 200) {
            const data = response?.data?.data[0];

            // Check for empty data
            if (!data) {
              // Set validation error for pincode
              setValidationErrors((prevErrors) => ({
                ...prevErrors,
                pincode: "Invalid Pincode*",
              }));
              setFormData((prevData) => ({
                ...prevData,
                city: "",
                state: "",
                country: "",
              }));
            } else {
              // If valid, update formData and clear any previous pincode validation error
              setFormData((prevData) => ({
                ...prevData,
                city: data?.city_name,
                city_id: data?.city_id,
                state: data?.state_name,
                state_id: data?.state_id,
                country: data?.country_name,
                country_id: data?.country_id,
              }));

              setValidationErrors((prevErrors) => ({
                ...prevErrors,
                pincode: "", // Clear pincode error if valid
              }));
            }
          } else {
            throw new Error("Failed to fetch data");
          }
        } catch (error) {
          // console.error("Error fetching data:", error);
          setValidationErrors((prevErrors) => ({
            ...prevErrors,
            // pincode: "Failed to fetch data", // Set error message if request fails
          }));
        }
      };

      fetchPincodeData();
    }
  }, [pincode]);

  useEffect(() => {
    if (formData?.pincode?.length === 6) {
      setPincode(formData?.pincode);
    }
  }, [formData?.pincode]);

  // Calculate tax_percent from prepopulated Customer Purchase Order data
  useEffect(() => {
    if (
      formData?.basepriceCustomerPrchaseOrder &&
      formData?.taxamountCustomerPurchaseOrder &&
      !formData?.tax_percent
    ) {
      const baseprice =
        parseFloat(
          formData.basepriceCustomerPrchaseOrder.toString().replace(/,/g, ""),
        ) || 0;
      const taxamount =
        parseFloat(
          formData.taxamountCustomerPurchaseOrder.toString().replace(/,/g, ""),
        ) || 0;

      if (baseprice > 0) {
        const calculatedTaxPercent = ((taxamount / baseprice) * 100).toFixed(2);
        setFormData((prevData) => ({
          ...prevData,
          tax_percent: parseFloat(calculatedTaxPercent),
        }));
      }
    }
  }, [
    formData?.basepriceCustomerPrchaseOrder,
    formData?.taxamountCustomerPurchaseOrder,
  ]);

  const handleFileChange = (e, name) => {
    const files = Array.from(e.target.files);
    const fieldConfig = formConfig?.find((f) => f.name === name);

    // Dynamic extensions and size with fallbacks
    const allowedExts = fieldConfig?.validation?.allowedExtensions ||
      fieldConfig?.allowedExtensions || ["jpg", "jpeg", "png", "pdf"];
    const maxSizeMB =
      fieldConfig?.validation?.maxSizeMB || fieldConfig?.maxSizeMB || 2;
    const maxSize = maxSizeMB * 1024 * 1024;

    for (let file of files) {
      const fileExtension = file.name.split(".").pop().toLowerCase();

      if (!allowedExts.includes(fileExtension)) {
        alert(
          `Only ${allowedExts.join(", ").toUpperCase()} files are allowed.`,
        );
        setValidationErrors((prev) => ({
          ...prev,
          [name]: `Invalid file type. Only ${allowedExts.join(", ").toUpperCase()} allowed.`,
        }));
        return;
      }

      if (file.size > maxSize) {
        alert(`File size cannot exceed ${maxSizeMB}MB.`);
        setValidationErrors((prev) => ({
          ...prev,
          [name]: `File size cannot exceed ${maxSizeMB}MB.`,
        }));
        return;
      }
    }

    setValidationErrors((prev) => ({ ...prev, [name]: "" }));

    setFormData((prevData) => {
      const existingFiles = prevData[name] || [];
      const maxFiles =
        fieldConfig?.validation?.maxFiles || fieldConfig?.maxFiles || 5;

      if (existingFiles.length + files.length > maxFiles) {
        alert(`You can only upload a maximum of ${maxFiles} files.`);
        return prevData;
      }
      return { ...prevData, [name]: [...existingFiles, ...files] };
    });

    setFileNames((prevNames) => ({
      ...prevNames,
      [name]: files.map((file) => file.name).join(", "),
    }));
  };

  // const handleFileChange = (e, name) => {
  //   const files = Array.from(e.target.files);

  //   // Allowed extensions & size
  //   const allowedExtensions = ["jpg", "jpeg", "png", "pdf"];
  //   const maxSize = 20 * 1024 * 1024; // 20MB

  //   // ---------- VALIDATION ----------
  //   for (let file of files) {
  //     const fileExtension = file.name.split(".").pop().toLowerCase();

  //     // File type validation
  //     if (!allowedExtensions.includes(fileExtension)) {
  //       alert("Only JPG, JPEG, PNG and PDF files are allowed.");

  //       setValidationErrors((prev) => ({
  //         ...prev,
  //         [name]: "Invalid file type. Only JPG, JPEG, PNG and PDF allowed.",
  //       }));

  //       return;
  //     }

  //     // File size validation
  //     if (file.size > maxSize) {
  //       alert("File size cannot exceed 20MB.");

  //       setValidationErrors((prev) => ({
  //         ...prev,
  //         [name]: "File size cannot exceed 20MB.",
  //       }));

  //       return;
  //     }
  //   }

  //   // Clear validation error if all files are valid
  //   setValidationErrors((prev) => ({
  //     ...prev,
  //     [name]: "",
  //   }));

  //   // ---------- STATE UPDATE ----------
  //   setFormData((prevData) => {
  //     const existingFiles = prevData[name] || [];

  //     // Limit to maximum of 5 files
  //     if (existingFiles.length + files.length > 5) {
  //       alert(
  //         `You can only upload a maximum of 5 files. You currently have ${existingFiles.length} uploaded.`,
  //       );
  //       return prevData;
  //     }

  //     return {
  //       ...prevData,
  //       [name]: [...existingFiles, ...files],
  //     };
  //   });

  //   // ---------- UI FILE NAMES ----------
  //   setFileNames((prevNames) => ({
  //     ...prevNames,
  //     [name]: files.map((file) => file.name).join(", "),
  //   }));
  // };

  const handleChangeForPaymentStatus = (name, value, type) => {
    // console.log(name, value, "namevalueforfile");

    //  ALLOWED FILE VALIDATION
    // -------------------------------------
    // if (type === "file" && value) {
    //   const allowedExtensions = ["jpg", "jpeg", "png"];
    //   const fileExtension = value.name.split(".").pop().toLowerCase();

    //   if (!allowedExtensions.includes(fileExtension)) {
    //     alert("Only JPG, JPEG and PNG files are allowed.");

    //     // Set validation error
    //     setValidationErrors((prev) => ({
    //       ...prev,
    //       [name]: "Invalid file type. Only JPG, JPEG, PNG allowed.",
    //     }));

    //     return; // Stop further processing
    //   } else {
    //     // Clear error if valid
    //     setValidationErrors((prev) => ({
    //       ...prev,
    //       [name]: "",
    //     }));
    //   }
    // }

    if (type === "file" && value) {
      const fieldConfig = formConfig?.find((f) => f.name === name);
      const allowedExts = fieldConfig?.validation?.allowedExtensions ||
        fieldConfig?.allowedExtensions || ["jpg", "jpeg", "png"];
      const maxSizeMB =
        fieldConfig?.validation?.maxSizeMB || fieldConfig?.maxSizeMB || 2;
      const maxSize = maxSizeMB * 1024 * 1024;
      const fileExtension = value.name.split(".").pop().toLowerCase();

      if (!allowedExts.includes(fileExtension)) {
        alert(
          `Only ${allowedExts.join(", ").toUpperCase()} files are allowed.`,
        );
        setValidationErrors((prev) => ({
          ...prev,
          [name]: `Invalid file type. Only ${allowedExts.join(", ").toUpperCase()} allowed.`,
        }));
        return;
      }

      if (value.size > maxSize) {
        alert(`File size cannot exceed ${maxSizeMB}MB.`);
        setValidationErrors((prev) => ({
          ...prev,
          [name]: `File size cannot exceed ${maxSizeMB}MB`,
        }));
        return;
      }

      setValidationErrors((prev) => ({ ...prev, [name]: "" }));
    }

    if (type === "file" && value) {
      const maxSize = 25 * 1024 * 1024;

      if (value.size > maxSize) {
        alert("File size cannot exceed 20MB.");

        // OR if you are using SweetAlert:
        // Swal.fire({
        //   icon: "error",
        //   title: "File too large",
        //   text: "File size cannot exceed 20MB.",
        // });

        // Set validation error
        setValidationErrors((prev) => ({
          ...prev,
          [name]: "File size cannot exceed 20MB",
        }));

        return;
      } else {
        setValidationErrors((prev) => ({
          ...prev,
          [name]: "",
        }));
      }
    }

    // Helper function to parse a number from a string with commas
    // const parseNumber = (numStr) => parseFloat(numStr.replace(/,/g, "")) || 0;
    const parseNumber = (numStr) => {
      if (numStr === null || numStr === undefined) return 0;
      return parseFloat(numStr.toString().replace(/,/g, "")) || 0;
    };

    setFormData((prevFormData) => {
      const updatedFormData = {
        ...prevFormData,
        [name]: value,
      };

      // --- Warranty Days Calculation ---
      if (
        (name === "warrantyFromVal" || name === "warrantyToVal") &&
        updatedFormData.warrantyFromVal &&
        updatedFormData.warrantyToVal
      ) {
        const fromDate = new Date(updatedFormData.warrantyFromVal);
        const toDate = new Date(updatedFormData.warrantyToVal);

        if (!isNaN(fromDate) && !isNaN(toDate)) {
          const timeDiff = toDate.getTime() - fromDate.getTime();
          const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

          updatedFormData.warrantyDays = daysDiff > 0 ? daysDiff : 0;
        } else {
          updatedFormData.warrantyDays = "";
        }
      }

      return updatedFormData;
    });

    // Handle baseprice logic...
    if (name === "baseprice") {
      const basePrice = parseNumber(value);
      const taxPercent = parseFloat(formData.tax_percent) || 0;
      const taxAmount = ((basePrice * taxPercent) / 100).toFixed(2);
      const totalAmount = (basePrice + parseFloat(taxAmount)).toFixed(2);

      setFormData((prevFormData) => ({
        ...prevFormData,
        taxamount: taxAmount,
        totalamount: totalAmount,
      }));
    }

    // Handle downPayment - financeAmt logic
    if (name === "downPayment") {
      const parseNumber = (numStr) =>
        parseFloat((numStr || "").toString().replace(/,/g, "")) || 0;
      const downPaymentVal = parseNumber(value);
      const totalAmountVal = parseNumber(formData.totalamount);

      if (!isNaN(downPaymentVal) && !isNaN(totalAmountVal)) {
        const financeAmt = totalAmountVal - downPaymentVal;

        setFormData((prevFormData) => ({
          ...prevFormData,
          financeAmt: financeAmt >= 0 ? financeAmt.toFixed(2) : "0.00",
        }));
      }
    }

    // Handle generate order calculations...
    if (["quantity", "basePrice", "tax"].includes(name)) {
      const quantity =
        name === "quantity"
          ? parseNumber(value)
          : parseNumber(formData.quantity);
      const basePrice =
        name === "basePrice"
          ? parseNumber(value)
          : parseNumber(formData.basePrice);
      const tax =
        name === "tax" ? parseNumber(value) : parseNumber(formData.tax);

      if (quantity && basePrice && tax) {
        const taxMultiplier = 1 + tax / 100;
        const taxAmount = (quantity * (basePrice * (tax / 100))).toFixed(2);
        let totalAmount = (quantity * basePrice * taxMultiplier).toFixed(2);
        let taxAmountForOneUnit = (basePrice * (tax / 100)).toFixed(2);
        let gstamtplustaxamout = basePrice + parseFloat(taxAmountForOneUnit);

        let totalAmountNum = parseFloat(totalAmount);
        let decimalPart = totalAmountNum % 1;

        totalAmountNum =
          decimalPart > 0.5
            ? Math.ceil(totalAmountNum)
            : Math.floor(totalAmountNum);

        setFormData((prevFormData) => ({
          ...prevFormData,
          totalAmount: totalAmountNum.toFixed(2),
          taxamount: taxAmount,
          basePricewithGst: gstamtplustaxamout.toFixed(2),
        }));
      } else {
        setFormData((prevFormData) => ({
          ...prevFormData,
          totalAmount: "",
        }));
      }
    }

    // Handle discount logic...
    if (name === "discount_type" || name === "discount") {
      const discountType =
        name === "discount_type" ? value : formData.discount_type;
      const discountValue =
        name === "discount"
          ? parseFloat(value) || 0
          : parseFloat(formData.discount) || 0;
      const totalAmount = parseNumber(formData.totalamount);

      if (discountType && totalAmount > 0) {
        let finalAmount;

        if (discountType === "A") {
          finalAmount = totalAmount - discountValue;
        } else if (discountType === "P") {
          finalAmount = totalAmount - (totalAmount * discountValue) / 100;
        }

        finalAmount = finalAmount > 0 ? finalAmount : 0;

        setFormData((prevFormData) => ({
          ...prevFormData,
          totalamount: finalAmount
            .toFixed(2)
            .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        }));
      }
    }

    // Validation logic
    validateField(name, value);
  };

  const handleChange = (name, value, type, allowedExtensions) => {
    // console.log(name, value, "namevalueforfile");

    // if (type === "file" && value) {
    //   const maxSize = 25 * 1024 * 1024;

    //   if (value.size > maxSize) {
    //     alert("File size cannot exceed 20MB.");

    //     // OR if you are using SweetAlert:
    //     // Swal.fire({
    //     //   icon: "error",
    //     //   title: "File too large",
    //     //   text: "File size cannot exceed 20MB.",
    //     // });

    //     // Set validation error
    //     setValidationErrors((prev) => ({
    //       ...prev,
    //       [name]: "File size cannot exceed 20MB",
    //     }));

    //     return;
    //   } else {
    //     setValidationErrors((prev) => ({
    //       ...prev,
    //       [name]: "",
    //     }));
    //     setFileNames((prev) => ({
    //       ...prev,
    //       [name]: value.name,
    //     }));
    //   }

    //   if (
    //     allowedExtensions &&
    //     Array.isArray(allowedExtensions) &&
    //     allowedExtensions.length > 0
    //   ) {
    //     const fileExtension = value.name.split(".").pop().toLowerCase();
    //     const alertMessage = `Only ${allowedExtensions.join(
    //       ", ",
    //     )} files are allowed.`;
    //     if (!allowedExtensions.includes(fileExtension)) {
    //       alert(alertMessage);

    //       // Set validation error
    //       setValidationErrors((prev) => ({
    //         ...prev,
    //         [name]: `Invalid file type. ${alertMessage}`,
    //       }));

    //       return; // Stop further processing
    //     } else {
    //       // Clear error if valid
    //       setValidationErrors((prev) => ({
    //         ...prev,
    //         [name]: "",
    //       }));
    //     }
    //   }
    // }

    if (type === "file" && value) {
      const fieldConfig = formConfig?.find((f) => f.name === name);

      // Dynamic rules prioritizing function argument > JSON validation > JSON root > defaults
      const allowedExts = allowedExtensions ||
        fieldConfig?.validation?.allowedExtensions ||
        fieldConfig?.allowedExtensions || ["jpg", "jpeg", "png", "pdf"];
      const maxSizeMB =
        fieldConfig?.validation?.maxSizeMB || fieldConfig?.maxSizeMB || 2;
      const maxSize = maxSizeMB * 1024 * 1024;

      const fileExtension = value.name.split(".").pop().toLowerCase();

      if (!allowedExts.includes(fileExtension)) {
        const alertMessage = `Only ${allowedExts.join(", ").toUpperCase()} files are allowed.`;
        alert(alertMessage);
        setValidationErrors((prev) => ({
          ...prev,
          [name]: `Invalid file type. ${alertMessage}`,
        }));
        return;
      }

      if (value.size > maxSize) {
        alert(`File size cannot exceed ${maxSizeMB}MB.`);
        setValidationErrors((prev) => ({
          ...prev,
          [name]: `File size cannot exceed ${maxSizeMB}MB`,
        }));
        return;
      }

      setValidationErrors((prev) => ({ ...prev, [name]: "" }));
      setFileNames((prev) => ({ ...prev, [name]: value.name }));
    }

    // Helper function to parse a number from a string with commas
    // const parseNumber = (numStr) => parseFloat(numStr.replace(/,/g, "")) || 0;
    const parseNumber = (numStr) => {
      if (numStr === null || numStr === undefined) return 0;
      return parseFloat(numStr.toString().replace(/,/g, "")) || 0;
    };

    setFormData((prevFormData) => {
      const updatedFormData = {
        ...prevFormData,
        [name]: value,
      };

      // --- Warranty Days Calculation ---
      if (
        (name === "warrantyFromVal" || name === "warrantyToVal") &&
        updatedFormData.warrantyFromVal &&
        updatedFormData.warrantyToVal
      ) {
        const fromDate = new Date(updatedFormData.warrantyFromVal);
        const toDate = new Date(updatedFormData.warrantyToVal);

        if (!isNaN(fromDate) && !isNaN(toDate)) {
          const timeDiff = toDate.getTime() - fromDate.getTime();
          const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

          updatedFormData.warrantyDays = daysDiff > 0 ? daysDiff : 0;
        } else {
          updatedFormData.warrantyDays = "";
        }
      }

      return updatedFormData;
    });

    // Handle baseprice logic...
    if (name === "baseprice") {
      const basePrice = parseNumber(value);
      const taxPercent = parseFloat(formData.tax_percent) || 0;
      const taxAmount = ((basePrice * taxPercent) / 100).toFixed(2);
      const totalAmount = (basePrice + parseFloat(taxAmount)).toFixed(2);

      setFormData((prevFormData) => ({
        ...prevFormData,
        taxamount: taxAmount,
        totalamount: totalAmount,
      }));
    }

    // Handle downPayment - financeAmt logic
    if (name === "downPayment") {
      const parseNumber = (numStr) =>
        parseFloat((numStr || "").toString().replace(/,/g, "")) || 0;
      const downPaymentVal = parseNumber(value);
      const totalAmountVal = parseNumber(formData.totalamount);

      if (!isNaN(downPaymentVal) && !isNaN(totalAmountVal)) {
        const financeAmt = totalAmountVal - downPaymentVal;

        setFormData((prevFormData) => ({
          ...prevFormData,
          financeAmt: financeAmt >= 0 ? financeAmt.toFixed(2) : "0.00",
        }));
      }
    }

    // Handle basepriceCustomerPrchaseOrder - Customer Purchase Order logic
    if (name === "basepriceCustomerPrchaseOrder") {
      const basePrice = parseNumber(value);
      const taxPercent = parseFloat(formData.tax_percent) || 0;

      if (!isNaN(basePrice)) {
        const taxAmount = ((basePrice * taxPercent) / 100).toFixed(2);
        const totalAmount = (basePrice + parseFloat(taxAmount)).toFixed(2);

        setFormData((prevFormData) => ({
          ...prevFormData,
          taxamountCustomerPurchaseOrder: taxAmount,
          totalamountCustomerPurchaseOrder: totalAmount,
        }));
      }
    }

    if (["quantity", "basePrice", "tax"].includes(name)) {
      const quantity =
        name === "quantity"
          ? parseNumber(value)
          : parseNumber(formData.quantity);
      const basePrice =
        name === "basePrice"
          ? parseNumber(value)
          : parseNumber(formData.basePrice);
      const tax =
        name === "tax" ? parseNumber(value) : parseNumber(formData.tax);

      if (quantity && basePrice) {
        let taxAmount = 0;
        let totalAmount = 0;
        let gstamtplustaxamout = basePrice;

        if (tax === 0) {
          // When tax is 0.00, taxAmount is 0, totalAmount is quantity * basePrice
          taxAmount = "0.00";
          totalAmount = (quantity * basePrice).toFixed(2);
          gstamtplustaxamout = basePrice.toFixed(2);
        } else if (tax > 0) {
          // Existing logic for tax > 0
          const taxMultiplier = 1 + tax / 100;
          taxAmount = (quantity * (basePrice * (tax / 100))).toFixed(2);
          totalAmount = (quantity * basePrice * taxMultiplier).toFixed(2);
          const taxAmountForOneUnit = (basePrice * (tax / 100)).toFixed(2);
          gstamtplustaxamout = (
            basePrice + parseFloat(taxAmountForOneUnit)
          ).toFixed(2);
        }

        // Apply rounding logic to totalAmount
        let totalAmountNum = parseFloat(totalAmount);
        let decimalPart = totalAmountNum % 1;
        totalAmountNum =
          decimalPart > 0.5
            ? Math.ceil(totalAmountNum)
            : Math.floor(totalAmountNum);

        setFormData((prevFormData) => ({
          ...prevFormData,
          totalAmount: totalAmountNum.toFixed(2),
          taxamount: taxAmount,
          basePricewithGst: gstamtplustaxamout,
        }));
      } else {
        setFormData((prevFormData) => ({
          ...prevFormData,
          totalAmount: "",
          taxamount: "",
          basePricewithGst: "",
        }));
      }
    }

    // Handle discount logic...
    if (name === "discount_type" || name === "discount") {
      const discountType =
        name === "discount_type" ? value : formData.discount_type;
      const discountValue =
        name === "discount"
          ? parseFloat(value) || 0
          : parseFloat(formData.discount) || 0;
      const totalAmount = parseNumber(formData.totalamount);

      if (discountType && totalAmount > 0) {
        let finalAmount;

        if (discountType === "A") {
          finalAmount = totalAmount - discountValue;
        } else if (discountType === "P") {
          finalAmount = totalAmount - (totalAmount * discountValue) / 100;
        }

        finalAmount = finalAmount > 0 ? finalAmount : 0;

        setFormData((prevFormData) => ({
          ...prevFormData,
          totalamount: finalAmount
            .toFixed(2)
            .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        }));
      }
    }

    // Validation logic
    validateField(name, value);
  };

  const validateField = (name, value) => {
    const fieldConfig = formConfig?.find((field) => field.name === name);

    if (fieldConfig && fieldConfig?.validation) {
      const {
        required,
        minLength,
        maxLength,
        maxValue,
        maxAmount,
        pattern,
        message,
        message1,
        accept,
        responseerrormessage,
      } = fieldConfig.validation;

      let error = "";

      if (value instanceof File) {
        const fileExtension = value.name.split(".").pop().toLowerCase();

        // Fetch dynamic config
        const allowedExts = fieldConfig?.validation?.allowedExtensions ||
          fieldConfig?.allowedExtensions || ["jpg", "jpeg", "png", "pdf"];
        const maxSizeMB =
          fieldConfig?.validation?.maxSizeMB || fieldConfig?.maxSizeMB || 2;
        const maxSize = maxSizeMB * 1024 * 1024;

        if (!allowedExts.includes(fileExtension)) {
          error = `Invalid file format. Allowed formats: ${allowedExts.join(", ")}`;
        }
        if (value.size > maxSize) {
          error = `File size should not exceed ${maxSizeMB} MB`;
        }
      }

      // 1. Safe parsing of length, ignoring the decimal dot
      const valString =
        value !== null && value !== undefined ? String(value) : "";
      const lengthForValidation = fieldConfig.isDecimal
        ? valString.replace(".", "").length
        : valString.length;

      // ... [Keep your file & GST validation logic here if you have any] ...

      // 2. Strict Order of Validation Checks
      if (required && valString.trim() === "") {
        // Check 1: Is it empty?
        error = "This field is required*";
      } else if (valString.length > 0) {
        // Check 2: Does it fail the Regex Pattern?
        if (pattern && !pattern.test(valString)) {
          error = message1 || message || "Invalid format";
        }
        // Check 3: Is it too short? (Fires when length is 1 and minLength is 2)
        else if (minLength && lengthForValidation < minLength) {
          error =
            message ||
            `Minimum length is ${minLength} ${fieldConfig?.type === "number" ? "digits" : "characters"}`;
        }
        // Check 4: Is it too long?
        else if (maxLength && lengthForValidation > maxLength) {
          error =
            message ||
            `Maximum length is ${maxLength} ${fieldConfig?.type === "number" ? "digits" : "characters"}`;
        }
        // Check 5: Max Value / Max Amount
        else if (maxValue && parseFloat(valString) > maxValue) {
          error = `Quantity Exceeded`;
        } else if (
          maxAmount !== undefined &&
          parseFloat(valString) > parseFloat(maxAmount)
        ) {
          error = `Amount cannot exceed ₹${maxAmount}`;
        }
        // Check 6: API Error
        else if (responseerrormessage) {
          error = responseerrormessage;
        }
      }

      // Update state
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        [name]: error,
      }));
    }
  };

  // --- ADD THIS RIGHT AFTER validateField ---
  const hasValidatedInitialData = useRef(false);

  useEffect(() => {
    // 1. Check if we requested mount validation
    // 2. Check if API data has arrived (formData has keys)
    // 3. Ensure we only run this once using the useRef
    if (
      validateOnMount &&
      Object.keys(formData).length > 0 &&
      !hasValidatedInitialData.current
    ) {
      // Loop through all fields in the JSON config
      formConfig?.forEach((field) => {
        const value = formData[field.name];

        // Run the validation function on the pre-filled data
        if (value !== undefined && value !== null) {
          validateField(field.name, value);
        }
      });

      // Mark as done so it doesn't re-run on every user keystroke
      hasValidatedInitialData.current = true;
    }
  }, [formData, formConfig, validateOnMount]);

  const allowedKeys = {
    numbersOnly: /^[0-9]$/,
    decimalnumber: /^[0-9.]$/,
    alphanumeric: /^[a-zA-Z0-9]$/,
    controlKeys: ["Backspace", "Delete", "ArrowLeft", "ArrowRight"],
  };

  const inputKeyPatterns = {
    contact_no: allowedKeys.numbersOnly,
    mobile: allowedKeys.numbersOnly,
    altmobile: allowedKeys.numbersOnly,
    contactno: allowedKeys.numbersOnly,
    pincode: allowedKeys.numbersOnly,
    discount: allowedKeys.decimalnumber,
    accountno: allowedKeys.alphanumeric,
    hsnname: allowedKeys.numbersOnly,
    hsnCode: allowedKeys.numbersOnly,
    hsncode: allowedKeys.numbersOnly,
    cubic_capacity: allowedKeys.decimalnumber,
    exshowroomprice: allowedKeys.decimalnumber,
    platecharge: allowedKeys.decimalnumber,
    insurancecharge: allowedKeys.decimalnumber,
    rtoregiamountcorp: allowedKeys.decimalnumber,
    rtoregiamountindi: allowedKeys.decimalnumber,
    estimatedcost: allowedKeys.decimalnumber,
    estimated_cost: allowedKeys.decimalnumber,
    discount: allowedKeys.decimalnumber,
    level1_approveal: allowedKeys.decimalnumber,
    level2_approveal: allowedKeys.decimalnumber,
  };

  const handleKeyPress = (name, e, type) => {
    const fieldConfig = formConfig?.find((f) => f.name === name);

    // Logic for Decimal Fields
    if (fieldConfig?.validation?.isDecimal) {
      const currentValue = formData[name]?.toString() || "";

      // Block exponent 'e' and symbols '+', '-'
      if (["e", "E", "+", "-"].includes(e.key)) {
        e.preventDefault();
        return;
      }

      // Block a second decimal point
      if (e.key === "." && currentValue.includes(".")) {
        e.preventDefault();
        return;
      }
    }

    // Block decimals if isInteger is true
    if (
      fieldConfig?.validation?.isInteger &&
      (e.key === "." || e.key === "e" || e.key === "E")
    ) {
      e.preventDefault();
      return;
    }

    if (name === "pincode") {
      const currentValue = formData[name]?.toString() || "";
      if (
        currentValue.length >= 6 &&
        e.key !== "Backspace" &&
        e.key !== "Delete" &&
        !allowedKeys.controlKeys.includes(e.key)
      ) {
        e.preventDefault();
        return;
      }
    }

    if (type === "text" && inputKeyPatterns[name]) {
      const { key } = e;
      const allowedPattern = inputKeyPatterns[name];

      if (!allowedPattern.test(key) && !allowedKeys.controlKeys.includes(key)) {
        e.preventDefault();
      }
    }
  };

  useEffect(() => {
    if (images && images.length > 0) {
      const initialFileNames = {};
      const initialFormData = {};
      images.forEach((image) => {
        initialFileNames[image?.document_type] = image?.document;
        initialFormData[image?.document_type] = image?.image_path;
      });
      setFileNames(initialFileNames);
      setFormData((prevData) => ({
        ...prevData,
        ...initialFormData,
      }));
    }
  }, [images, setFormData]);

  useEffect(() => {
    if (formData?.exchange) {
      setShowParentDesignation(true);
    }
  }, [formData?.exchange]);

  const handleMultiSelectChange = (name, selectedOptions) => {
    const selectedValues = selectedOptions.map((option) => option.value);
    setFormData({ ...formData, [name]: selectedValues });
    // console.log("nameselectedvalues", name, selectedValues);

    validateField(name, selectedValues);
  };

  const handleDropdownChange = (name, selectedOption) => {
    if (name === "productName") {
      setFormData({
        ...formData,
        [name]: selectedOption?.value,
        subproductName: null,
      });
    } else if (name === "city") {
      setFormData((prevData) => ({
        ...prevData,
        city: selectedOption?.value, // store city_id (matches dropdown value)
        city_name: selectedOption?.label, // optional: keep city name if needed
        state: selectedOption?.state,
        state_id: selectedOption?.state_id,
        country: selectedOption?.country,
        country_id: selectedOption?.country_id,
      }));
    } else {
      setFormData({
        ...formData,
        [name]: selectedOption?.value,
      });
    }

    validateField(name, selectedOption ? selectedOption?.value : null);
  };

  const handleRemoveFile = (name, index) => {
    setFormData((prevData) => {
      const existingFiles = prevData[name] || [];

      // Filter out the removed file
      const updatedFiles = existingFiles.filter((_, i) => i !== index);

      // Update fileNames based on the updatedFiles
      setFileNames((prevNames) => ({
        ...prevNames,
        [name]: updatedFiles.map((file) => file.name).join(", "),
      }));

      return { ...prevData, [name]: updatedFiles };
    });
  };

  const isRichTextEmpty = (value) => {
    if (!value) return true;

    // Remove HTML tags
    const text = value
      .replace(/<(.|\n)*?>/g, "") // remove HTML tags
      .replace(/&nbsp;/g, " ") // replace &nbsp;
      .trim();

    return text.length === 0;
  };

  // const handleRichTextChange = (name, value) => {
  //   setFormData({ ...formData, [name]: value });
  //   validateField(name, value);
  // };

  const handleRichTextChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (isRichTextEmpty(value)) {
      setValidationErrors((prev) => ({
        ...prev,
        [name]: "This field is required*",
      }));
    } else {
      setValidationErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  // 1. Helper to determine the beautiful icon and color based on extension
  const getFileIcon = (fileName, size = "50px") => {
    const ext = fileName?.split(".").pop().toLowerCase();
    const iconStyle = { width: size, height: size, marginTop: "10px" };

    switch (ext) {
      case "pdf":
        return <FaFilePdf style={{ ...iconStyle, color: "#e2574c" }} />;
      case "csv":
        return <FaFileCsv style={{ ...iconStyle, color: "#28a745" }} />;
      case "xls":
      case "xlsx":
        return <FaFileExcel style={{ ...iconStyle, color: "#1d6f42" }} />;
      case "doc":
      case "docx":
        return <FaFileWord style={{ ...iconStyle, color: "#2b579a" }} />;
      case "png":
      case "jpg":
      case "jpeg":
        return <FaFileImage style={{ ...iconStyle, color: "#7BD755" }} />;
      default:
        return <FaFileAlt style={{ ...iconStyle, color: "#6c757d" }} />;
    }
  };

  const renderFilePreviews = (files, fieldName) => {
    return files.map((file, index) => {
      const fileURL = URL.createObjectURL(file);
      const isImage = file.type.startsWith("image/");

      return (
        <div
          key={index}
          style={{
            marginTop: "10px",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            background: "#f8f9fa", // Added subtle background
            padding: "8px 12px", // Added padding for a modern look
            borderRadius: "8px", // Rounded corners
            border: "1px solid #eaeaea",
            boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
          }}
        >
          {isImage ? (
            <img
              src={fileURL}
              alt="Preview"
              style={{
                width: "30px",
                height: "30px",
                objectFit: "cover",
                borderRadius: "4px",
              }}
            />
          ) : (
            getFileIcon(file.name, "25px")
          )}

          <p
            style={{
              margin: 0,
              flexGrow: 1,
              fontSize: "14px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              color: "#333",
            }}
          >
            {file.name}
          </p>

          <button
            type="button"
            onClick={() => handleRemoveFile(fieldName, index)}
            style={{
              background: "#ff4d4f",
              border: "none",
              color: "white",
              borderRadius: "50%",
              width: "24px",
              height: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              fontSize: "12px",
            }}
          >
            ✕
          </button>
        </div>
      );
    });
  };

  // 3. NEW: Universal Single File Preview Renderer (Cleans up your switch statement!)
  const renderSingleFilePreview = (fileData) => {
    if (!fileData) {
      return (
        <div style={{ marginTop: "10px" }}>
          <p style={{ fontSize: "15px", color: "#7BD755" }}>No file uploaded</p>
        </div>
      );
    }

    const isStringUrl = typeof fileData === "string";
    const fileName = isStringUrl ? fileData.split("/").pop() : fileData.name;
    const ext = fileName?.split(".").pop().toLowerCase();
    const isImage = ["jpg", "jpeg", "png", "gif"].includes(ext);

    // Create URL if it's a file blob, otherwise use the string URL directly
    const fileURL = isStringUrl ? fileData : URL.createObjectURL(fileData);

    return (
      <div
        style={{ marginTop: "10px", display: "flex", justifyContent: "center" }}
      >
        <a
          href={fileURL}
          download
          target="_blank"
          rel="noreferrer"
          style={{
            textDecoration: "none",
            color: "#7BD755",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {isImage ? (
            <img
              src={fileURL}
              alt="uploaded"
              style={{
                width: "100px",
                height: "100px",
                objectFit: "cover",
                marginTop: "10px",
                borderRadius: "8px",
                boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
              }}
            />
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {getFileIcon(fileName, "50px")}
              <p
                style={{
                  fontSize: "14px",
                  marginTop: "8px",
                  fontWeight: "500",
                }}
              >
                Download {ext?.toUpperCase()}
              </p>
            </div>
          )}
        </a>
      </div>
    );
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderColor: "#ccc",
      boxShadow: "none",
      borderRadius: "10px",
      "&:hover": {
        borderColor: "#888",
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      display: "flex",
      alignItems: "center",
      height: "50px",
      width: "200px",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "5px",
      borderColor: "#ccc",
      zIndex: 9999,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#7BD755"
        : state.isFocused
          ? "#fff"
          : null,
      // color: state.isSelected || state.isFocused ? "white" : "black",
      "&:hover": {
        backgroundColor: "#f2fcf0",
        color: "#000",
      },
    }),
  };

  const customStylesNew = {
    control: (provided) => ({
      ...provided,
      borderColor: "#ccc",
      boxShadow: "none",
      minHeight: "50px", // allow growth
      borderRadius: "10px",
      "&:hover": {
        borderColor: "#888",
      },
    }),

    valueContainer: (provided) => ({
      ...provided,
      display: "flex",
      alignItems: "center",
      minHeight: "50px",
      height: "auto",
      flexWrap: "wrap",
      width: "100%",
      padding: "6px 8px",
    }),

    menu: (provided) => ({
      ...provided,
      borderRadius: "5px",
      borderColor: "#ccc",
      zIndex: 9999,
    }),

    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#7BD755"
        : state.isFocused
          ? "#fff"
          : null,
      "&:hover": {
        backgroundColor: "#f2fcf0",
        color: "#000",
      },
    }),
  };

  const handleFileDrop = (e, name) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    setFormData({ ...formData, [name]: file });
    setFileNames({ ...fileNames, [name]: file.name });
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const renderField = (field) => {
    const additionalClass = field.gridClass ? ` ${field.gridClass}` : "";

    // --- NEW: Generate Dynamic UI strings for file uploads ---
    const allowedExts = field?.validation?.allowedExtensions ||
      field?.allowedExtensions || ["jpg", "jpeg", "png", "pdf"];
    const maxSizeMB = field?.validation?.maxSizeMB || field?.maxSizeMB || 2;
    const acceptString = allowedExts.map((ext) => `.${ext}`).join(", ");
    const fileHintText = `(File Format - ${allowedExts.join(", ").toUpperCase()}, Max limit ${maxSizeMB} MB)`;
    // ---------------------------------------------------------
    switch (field.type) {
      case "text":
      case "email":
      case "number":
        const inputType =
          field?.validation?.isDecimal || field?.validation?.isInteger
            ? "text"
            : field.type;

        const htmlMaxLength = field?.validation?.isDecimal
          ? undefined
          : field?.validation?.maxLength;

        return (
          <div key={field?.name} className="mt-2 mb-2">
            <label>
              {field?.label}{" "}
              {field.required && <span className="required-asterisk">*</span>}
            </label>
            {/* <input
              type={field?.type}
              name={field?.name}
              value={formData[field?.name] || ""}
              placeholder={field?.placeholder || ""}
              disabled={field?.disabled}
            
              maxLength={field?.validation && field?.validation?.maxLength}
              onChange={(e) =>
                handleChange(field.name, e.target.value, field.type)
              }
              onKeyDown={(e) => handleKeyPress(field.name, e, field.type)}
              className={`form-control ${validationErrors[field?.name] && "is-invalid"
                }`}
            /> */}
            <input
              type={inputType}
              inputMode="decimal"
              name={field?.name}
              value={formData[field?.name] || ""}
              placeholder={field?.placeholder || ""}
              disabled={field?.disabled}
              maxLength={htmlMaxLength}
              onChange={(e) => {
                let value = e.target.value;
                const originalValue = value;

                if (field?.validation?.isDecimal) {
                  // 1. Only allow digits and one dot
                  value = value.replace(/[^0-9.]/g, "");

                  const parts = value.split(".");
                  // Prevent multiple dots
                  if (parts.length > 2)
                    value = parts[0] + "." + parts.slice(1).join("");

                  // 2. Limit to decimal places
                  if (
                    parts[1] &&
                    parts[1].length > field?.validation?.decimalPlace
                  ) {
                    value =
                      parts[0] +
                      "." +
                      parts[1].substring(0, field?.validation?.decimalPlace);
                  }

                  // 3. Enforce maximum length (ignoring the dot)
                  const maxLength = field.validation?.maxLength;
                  if (maxLength) {
                    const valueWithoutDot = value.replace(".", "");
                    // if (valueWithoutDot.length > maxLength) return;
                    if (valueWithoutDot.length > maxLength) {
                      // DOM SYNC: Erase the extra character from the screen instantly
                      e.target.value = formData[field.name] || "";
                      return;
                    }
                  }

                  // FORCE DOM SYNC: If we stripped a "-" or letter, erase it from the screen
                  if (originalValue !== value) {
                    e.target.value = value;
                  }
                } else if (field?.validation?.isInteger) {
                  // Strictly integer validation
                  value = value.replace(/\D/g, "");
                  const maxLength = field.validation?.maxLength;
                  // if (maxLength && value.length > maxLength) return;
                  if (maxLength && value.length > maxLength) {
                    // DOM SYNC: Erase the extra character from the screen instantly
                    e.target.value = formData[field.name] || "";
                    return;
                  }

                  // 3. CRITICAL DOM SYNC: If we stripped a "-" or letter, erase it from the screen!
                  if (originalValue !== value) {
                    e.target.value = value;
                  }
                }

                if (value === " " || (value.length === 1 && value[0] === " "))
                  return;
                handleChange(field.name, value, field.type);
              }}
              onBlur={(e) => {
                // Trim value on blur (remove leading/trailing spaces)
                let trimmedValue = e.target.value.trim();

                // Because we are using type="text", JavaScript can finally see the "."
                if (
                  field?.validation?.isDecimal &&
                  trimmedValue.endsWith(".")
                ) {
                  trimmedValue = trimmedValue.slice(0, -1);
                }

                if (trimmedValue !== formData[field.name]) {
                  handleChange(field.name, trimmedValue, field.type);
                }
              }}
              onKeyDown={(e) => {
                if (
                  (field.type === "number" ||
                    field?.validation?.isDecimal ||
                    field?.validation?.isInteger) &&
                  (e.key === "-" || e.key === "+")
                ) {
                  e.preventDefault();
                }
                handleKeyPress(field.name, e, field.type);
              }}
              className={`form-control ${
                validationErrors[field?.name] ? "is-invalid" : ""
              }`}
            />
            {validationErrors[field?.name] && (
              <div className="error-feedback">
                {validationErrors[field?.name]}
              </div>
            )}
          </div>
        );

      case "kilometertext":
      case "kilometeremail":
      case "kilometernumber":
        return (
          <div key={field?.name} className="mt-2 mb-2">
            <label>
              {field?.label}{" "}
              {field.required && <span className="required-asterisk">*</span>}
            </label>
            <div style={{ display: "flex" }}>
              <div className="service-text-search-parent">
                <input
                  type={field?.type}
                  name={field?.name}
                  value={formData[field?.name] || ""}
                  placeholder={field?.placeholder || ""}
                  disabled={field?.disabled}
                  // minLength={2}
                  maxLength={field?.validation && field?.validation?.maxLength}
                  onChange={(e) =>
                    handleChange(field.name, e.target.value, field.type)
                  }
                  onKeyDown={(e) => handleKeyPress(field.name, e, field.type)}
                  className={`form-control service-text-search ${
                    validationErrors[field?.name] && "is-invalid"
                  }`}
                  style={{ width: "26rem" }}
                />
              </div>
              <div>
                {field?.isComplaint && (
                  <div
                    style={{
                      marginLeft: "7rem",
                      borderRadius: 10,
                      // width: 50,
                      cursor: "pointer",
                    }}
                    onClick={() => apiCallforKilometer(formData)}
                  >
                    {/* <img
                          style={{
                            height: "50px",
                            border: "1px solid grey",
                            borderRadius: "13px",
                          }}
                          src={searchIcon}
                          alt="Job Card Icon"
                        /> */}
                    <p
                      style={{
                        // height: "50px",
                        padding: "10px",
                        border: "1px solid #7BD755",
                        background: "#7BD755",
                        color: "white",
                        borderRadius: "13px",
                      }}
                    >
                      Validate
                    </p>
                  </div>
                )}
              </div>
            </div>

            {validationErrors[field?.name] && (
              <div className="error-feedback">
                {validationErrors[field?.name]}
              </div>
            )}
          </div>
        );

      case "servicetext":
      case "serviceemail":
      case "servicenumber":
        return (
          <div key={field?.name} className="mt-2 mb-2">
            <label>
              {field?.label}{" "}
              {field.required && <span className="required-asterisk">*</span>}
            </label>
            <div style={{ display: "flex" }}>
              <div className="service-text-search-parent">
                <input
                  type={field?.type}
                  name={field?.name}
                  value={formData[field?.name] || ""}
                  placeholder={field?.placeholder || ""}
                  disabled={field?.disabled}
                  // minLength={2}
                  maxLength={field?.validation && field?.validation?.maxLength}
                  onChange={(e) =>
                    handleChange(field.name, e.target.value, field.type)
                  }
                  onKeyDown={(e) => handleKeyPress(field.name, e, field.type)}
                  className={`form-control service-text-search ${
                    validationErrors[field?.name] && "is-invalid"
                  }`}
                  style={{ width: "26rem" }}
                />
              </div>
              <div>
                {field?.isComplaint && (
                  <div
                    style={{
                      marginLeft: "7rem",
                      borderRadius: 10,
                      width: 50,
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      apiCall(formData);
                    }}
                  >
                    <img
                      style={{
                        height: "50px",
                        border: "1px solid grey",
                        borderRadius: "13px",
                      }}
                      src={searchIcon}
                      alt="Job Card Icon"
                    />
                  </div>
                )}
              </div>
            </div>

            {validationErrors[field?.name] && (
              <div className="error-feedback">
                {validationErrors[field?.name]}
              </div>
            )}
          </div>
        );

      case "servicedropdown":
        return (
          <div key={field.name} className="mt-2 mb-2">
            <label>
              {field?.label}
              {field?.required && <span className="required-asterisk">*</span>}
            </label>
            <div
              className={`dropdown-wrapper ${
                field?.iscustomer ? "isCustomer" : ""
              }`}
              style={{ display: "flex", alignItems: "center" }}
            >
              <div
                className="service-text-search-parent"
                style={{ flexGrow: 1 }}
              >
                <Select
                  isClearable
                  key={field.name}
                  name={field.name}
                  isDisabled={field?.disabled}
                  options={field?.options}
                  styles={customStyles}
                  defaultValue={formData[field.name] || field.defaultValue}
                  value={
                    field?.options?.find(
                      (option) => option?.value === formData[field?.name],
                    ) || null
                  }
                  onChange={(selectedOption) =>
                    handleDropdownChange(field?.name, selectedOption)
                  }
                  menuPlacement={field?.dropdownOptionsListPosition || "auto"}
                />
              </div>
              {field?.iscustomer && (
                <div
                  style={{
                    marginLeft: 10,
                    borderRadius: 10,
                    width: 50,
                    cursor: "pointer",
                  }}
                  onClick={onclickOpenFrom}
                >
                  <img src={jobcardIcon} alt="Job Card Icon" />
                </div>
              )}
              <div>
                {field?.isComplaint && (
                  <div
                    style={{
                      marginLeft: "7rem",
                      borderRadius: 10,
                      width: 50,
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      apiCall(formData);
                    }}
                  >
                    <img
                      style={{
                        height: "50px",
                        border: "1px solid grey",
                        borderRadius: "13px",
                      }}
                      src={searchIcon}
                      alt="Job Card Icon"
                    />
                  </div>
                )}
              </div>
            </div>
            {validationErrors[field.name] && (
              <div className="customerror">{validationErrors[field.name]}</div>
            )}
          </div>
        );

      case "textarea":
        return (
          <div key={field.name} className="mt-2 mb-2">
            <label>
              {field.label}{" "}
              {field.required && <span className="required-asterisk">*</span>}
            </label>
            <textarea
              name={field.name}
              value={formData[field.name] || ""}
              placeholder={field.placeholder || ""}
              disabled={field.disabled}
              maxLength={field?.validation?.maxLength}
              rows={field.rows || 4}
              onChange={(e) =>
                handleChange(field.name, e.target.value, "textarea")
              }
              className={`form-control ${
                validationErrors[field.name] && "is-invalid"
              }`}
            />
            {validationErrors[field.name] && (
              <div className="invalid-feedback">
                {validationErrors[field.name]}
              </div>
            )}
          </div>
        );

      case "radio":
        return (
          <div key={field?.name} className={`${additionalClass} mt-3 mb-3`}>
            <div className="radiocontainer">
              <div className="parentClassRadio">
                <label>{field?.label}</label>

                <div className="childClassRadio">
                  {field?.options.map((option) => (
                    <div>
                      <div key={option.value} className="form-check">
                        <input
                          type="radio"
                          name={field?.name}
                          value={option?.value}
                          checked={formData[field?.name] === option.value}
                          onChange={(e) =>
                            handleChange(field.name, e.target.value, "radio")
                          }
                          className="form-check-input"
                        />
                        <label className="form-check-label">
                          {option.label}
                        </label>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {validationErrors[field.name] && (
              <div className="invalid-feedback">
                {validationErrors[field.name]}
              </div>
            )}
          </div>
        );

      case "multiselectcheckbox":
        return (
          <div
            key={field.name}
            className={`form-group${additionalClass} mt-3 mb-3`}
          >
            <label className="mt-3 mb-3 filelabel">
              {field.label}{" "}
              {field.required && <span className="required-asterisk">*</span>}
            </label>
            <div className="checkbox-container">
              {field.options.map((option) => (
                <div key={option.value} className="checkbox-item">
                  <input
                    type="checkbox"
                    name={option?.value}
                    checked={formData[option?.value] || false}
                    onChange={(e) =>
                      handleChange(option?.value, e.target.checked, "checkbox")
                    }
                    className="form-check-input"
                  />
                  <label className="form-check-label">{option?.label}</label>
                  {option.value === "totalUsers" && (
                    <input
                      style={{ width: "65px", height: "30px" }}
                      type="number"
                      name="totalUsersCount"
                      value={formData.totalUsersCount || ""}
                      onChange={(e) =>
                        handleChange(
                          "totalUsersCount",
                          e.target.value,
                          "number",
                        )
                      }
                      className="form-control"
                    />
                  )}
                  {option.value === "maxhierarchy" && (
                    <input
                      style={{ width: "65px", height: "30px" }}
                      type="number"
                      name="maxhierarchy"
                      value={formData.maxhierarchy || ""}
                      onChange={(e) =>
                        handleChange("maxhierarchy", e.target.value, "number")
                      }
                      className="form-control"
                    />
                  )}
                  {option.value === "userPrefix" && (
                    <input
                      style={{ width: "65px", height: "30px" }}
                      type="text"
                      name="userPrefix"
                      value={formData?.userPrefix || ""}
                      onChange={(e) =>
                        handleChange("userPrefix", e.target.value, "text")
                      }
                      className="form-control"
                    />
                  )}
                </div>
              ))}
            </div>
            {validationErrors[field.name] && (
              <div className="invalid-feedback">
                {validationErrors[field.name]}
              </div>
            )}
          </div>
        );
      case "multiselectdropdown":
        return (
          <div key={field?.name} className="mt-2 mb-2">
            <label>
              {field?.label}
              {field.required && <span className="required-asterisk">*</span>}
            </label>
            <Select
              isMulti
              name={field?.name}
              options={field?.options}
              styles={customStyles}
              //value={formData[field.name] || []}
              value={field?.options.filter((option) =>
                formData[field.name]?.includes(option.value),
              )}
              onChange={(selectedOptions) =>
                handleMultiSelectChange(field?.name, selectedOptions)
              }
              className={`select-control ${
                validationErrors[field.name] && "is-invalid"
              }`}
            />
            {validationErrors[field.name] && (
              <div className="customerror">{validationErrors[field.name]}</div>
            )}
          </div>
        );

      case "multiselectdropdownStockin":
        return (
          <div key={field?.name} className="mt-2 mb-2">
            <label>
              {field?.label}
              {field.required && <span className="required-asterisk">*</span>}
            </label>
            {/* <Select
              isMulti
              name={field?.name}
              options={field?.options}
              styles={customStyles}
              //value={formData[field.name] || []}
              value={field?.options.filter((option) =>
                formData[field.name]?.includes(option.value)
              )}
              onChange={(selectedOptions) =>
                handleMultiSelectChange(field?.name, selectedOptions)
              }
              className={`select-control ${
                validationErrors[field.name] && "is-invalid"
              }`}
            /> */}
            <Select
              isMulti
              name={field?.name}
              options={field?.options}
              closeMenuOnSelect={false}
              value={field?.options.filter((option) =>
                formData[field.name]?.includes(option.value),
              )}
              onChange={(selectedOptions) =>
                handleMultiSelectChange(field?.name, selectedOptions)
              }
              className={`select-control ${
                validationErrors[field.name] && "is-invalid"
              }`}
              styles={{
                ...customStylesNew,
                valueContainer: (base) => ({
                  ...base,
                  maxHeight: "120px",
                  overflowY: "auto",
                }),
              }}
            />
            {validationErrors[field?.name] && (
              <div className="invalid-feedback">
                {validationErrors[field.name]}
              </div>
            )}
          </div>
        );

      case "checkbox":
        return (
          <div key={field.name} className="mt-2 mb-2">
            <label className="form-label d-block mb-2">
              <input
                type="checkbox"
                checked={formData[field.name] || false}
                onChange={(e) =>
                  setFormData({ ...formData, [field.name]: e.target.checked })
                }
              />{" "}
              {field.label}
            </label>
          </div>
        );

      case "dropdown":
        return (
          <div key={field.name} className="mt-2 mb-2">
            <label>
              {field?.label}
              {field?.required && <span className="required-asterisk">*</span>}
            </label>
            <div
              className={`dropdown-wrapper ${
                field?.iscustomer ? "isCustomer" : ""
              }`}
              style={{ display: "flex", alignItems: "center" }}
            >
              <div style={{ flexGrow: 1 }}>
                <Select
                  isClearable
                  key={field.name}
                  name={field.name}
                  isDisabled={field?.disabled}
                  options={field?.options}
                  styles={customStyles}
                  defaultValue={formData[field.name] || field.defaultValue}
                  value={
                    field?.options?.find(
                      (option) => option?.value === formData[field?.name],
                    ) || null
                  }
                  onChange={(selectedOption) =>
                    handleDropdownChange(field?.name, selectedOption)
                  }
                  menuPlacement={field?.dropdownOptionsListPosition || "auto"}
                />
              </div>
              {field?.iscustomer && (
                <div
                  style={{
                    marginLeft: 10,
                    borderRadius: 10,
                    width: 50,
                    cursor: "pointer",
                  }}
                  onClick={onclickOpenFrom}
                >
                  <img src={jobcardIcon} alt="Job Card Icon" />
                </div>
              )}
            </div>
            {validationErrors[field.name] && (
              <div className="customerror">{validationErrors[field.name]}</div>
            )}
          </div>
        );

      case "richeditor":
        return (
          <div>
            <div
              style={{ paddingTop: "10px" }}
              key={field?.name}
              className={`form-group${additionalClass}`}
            >
              <label style={{ paddingRight: "260px" }} className="pt-2 pr-4">
                {field?.label}
                {field?.required && (
                  <span className="required-asterisk">*</span>
                )}
              </label>
              <ReactQuill
                value={formData[field?.name] || ""}
                onChange={(value) => handleRichTextChange(field?.name, value)}
                // className="rich-editor"
                modules={{
                  toolbar: {
                    container: [
                      ["bold", "italic", "underline", "strike"],
                      [{ header: "1" }, { header: "2" }, { font: [] }],
                      [{ size: [] }],
                      [{ list: "ordered" }, { list: "bullet" }],
                      ["link"],
                      ["clean"],
                    ],
                  },
                }}
                className={`rich-editor ${
                  validationErrors[field?.name] ? "is-invalid" : ""
                }`}
              />
            </div>
            <div>
              {validationErrors[field?.name] && (
                <div style={{ marginTop: "2rem" }} className="error-feedback">
                  {validationErrors[field?.name]}
                </div>
              )}
            </div>
          </div>
        );

      case "uploadFilepaymentStatus":
        return (
          <>
            <label
              className="pt-2 pr-4"
              style={{
                paddingBottom: "10px",
                paddingTop: "10px",
                paddingRight: "20px",
              }}
            >
              {field.label}
              {field?.required && <span className="required-asterisk">*</span>}
            </label>
            <div className="customFileUploadd">
              <div key={field.name} className={`form-group${additionalClass}`}>
                <div
                  className="file-drop-area pt-3"
                  onDrop={(e) => handleFileDrop(e, field.name)}
                  onDragOver={handleDragOver}
                >
                  <div className="">
                    <div className="custom-file-upload">
                      <input
                        type="file"
                        name={field.name}
                        id={field.name}
                        // onChange={(e) =>
                        //   handleChangeForPaymentStatus(
                        //     field.name,
                        //     e.target.files[0]
                        //   )
                        // }
                        onChange={(e) =>
                          handleChangeForPaymentStatus(
                            field.name,
                            e.target.files[0],
                            "file",
                          )
                        }
                        className="file-input"
                        style={{ display: "none" }}
                      />
                      <label htmlFor={field.name} className="custom-file-label">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <img src={uploadIcon} />
                          {fileNames[field.name] || (
                            <div>
                              <p style={{ fontSize: "15px" }}>
                                Drag your files here or{" "}
                                <span style={{ color: "#7BD755" }}>Browse</span>
                              </p>
                              <p
                                style={{ fontSize: "14px", fontWeight: "300" }}
                              >
                                (File Format - Jpeg, jpg)
                              </p>
                            </div>
                          )}
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
                {validationErrors[field.name] ? (
                  <div className="error-feedback">
                    {validationErrors[field.name]}
                  </div>
                ) : formData[field.name] ? (
                  <div style={{ marginTop: "10px", color: "#7BD755" }}>
                    File Uploaded successfully
                  </div>
                ) : null}
              </div>
            </div>
          </>
        );

      case "uploadFile":
        return (
          <>
            <label
              className="pt-2 pr-4"
              style={{
                paddingBottom: "10px",
                paddingTop: "10px",
                paddingRight: "20px",
              }}
            >
              {field.label}
              {field?.required && <span className="required-asterisk">*</span>}
            </label>
            <div className="customFileUploadd">
              <div key={field.name} className={`form-group${additionalClass}`}>
                <div
                  className="file-drop-area pt-3"
                  onDrop={(e) => handleFileDrop(e, field.name)}
                  onDragOver={handleDragOver}
                >
                  <div className="">
                    <div className="custom-file-upload">
                      <input
                        type="file"
                        name={field.name}
                        id={field.name}
                        onChange={(e) =>
                          handleChange(field.name, e.target.files[0])
                        }
                        className="file-input"
                        style={{ display: "none" }}
                      />
                      <label htmlFor={field.name} className="custom-file-label">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <img src={uploadIcon} />
                          {fileNames[field.name] || (
                            <div>
                              <p style={{ fontSize: "15px" }}>
                                Drag your files here or{" "}
                                <span style={{ color: "#7BD755" }}>Browse</span>
                              </p>
                              <p
                                style={{ fontSize: "14px", fontWeight: "300" }}
                              >
                                ((File Format - CSV))
                              </p>
                            </div>
                          )}
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
                {validationErrors[field.name] ? (
                  <div className="error-feedback">
                    {validationErrors[field.name]}
                  </div>
                ) : formData[field.name] ? (
                  <div style={{ marginTop: "10px", color: "#7BD755" }}>
                    File Uploaded successfully
                  </div>
                ) : null}
              </div>
            </div>
          </>
        );

      case "uploadCsvOrderManagement":
        // console.log(fileNames[field.name], "file names");
        return (
          <>
            <label style={{ paddingBottom: "10px", paddingTop: "10px" }}>
              {field.label}
              {field.required && <span className="required-asterisk">*</span>}
            </label>
            <div key={field.name} className={`form-group${additionalClass}`}>
              <div
                className="file-drop-area"
                onDrop={(e) => handleFileDrop(e, field.name)}
                onDragOver={handleDragOver}
              >
                <div className="customFileUploadd">
                  <div className="custom-file-upload">
                    <input
                      type="file"
                      name={field.name}
                      id={field.name}
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                          const fileName = file.name;
                          // Check for double extensions (more than one dot in filename)
                          if (fileName.split(".").length > 2) {
                            Swal.fire({
                              icon: "error",
                              title: "Invalid File Format",
                              text: "Double extensions are not allowed.",
                            });
                            setValidationErrors((prev) => ({
                              ...prev,
                              [field.name]:
                                "Double extensions are not allowed.",
                            }));
                            return;
                          }
                          // Clear any previous validation error for this field
                          setValidationErrors((prev) => {
                            const updated = { ...prev };
                            delete updated[field.name];
                            return updated;
                          });
                          // Proceed with handleChange
                          handleChange(
                            field.name,
                            file,
                            "file",
                            field?.allowedExtensions,
                          );
                        }
                      }}
                      multiple={field.multiple || false}
                      className="file-input"
                      style={{ display: "none" }}
                    />
                    <label htmlFor={field.name} className="custom-file-label">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img src={uploadIcon} alt="upload" />
                        {fileNames[field.name] &&
                        !validationErrors[field.name] ? (
                          <p style={{ fontSize: "14px", fontWeight: 500 }}>
                            {fileNames[field.name]}
                          </p>
                        ) : (
                          <div>
                            <p style={{ fontSize: "15px" }}>
                              Drag your files here or{" "}
                              <span style={{ color: "#7BD755" }}>Browse</span>
                            </p>
                            <p style={{ fontSize: "14px", fontWeight: "300" }}>
                              {/* (File Format - JPEG, JPG, PNG, PDF, Max limit 20
                              MB) */}
                            </p>
                          </div>
                        )}
                      </div>
                    </label>
                  </div>
                </div>
              </div>
              {formData?.[field?.name] && (
                <div
                  style={{ width: "100%" }}
                  className="d-flex justify-content-end"
                >
                  <button
                    type="button"
                    className="btn btn-link p-0"
                    style={{ color: "#7BD755" }}
                    onClick={() => {
                      handleChange(field.name, null, "file");
                      setFileNames((prev) => {
                        const updated = { ...prev };
                        delete updated[field.name];
                        return updated;
                      });
                      document.getElementById(field.name).value = "";
                    }}
                  >
                    Clear
                  </button>
                </div>
              )}

              {formData[field.name] ? (
                typeof formData[field.name] === "string" ? ( // Check if it's a URL
                  <div style={{ marginTop: "10px" }}>
                    {formData[field.name].endsWith(".pdf") ? ( // Check if file is a PDF
                      <div>
                        <a
                          href={formData[field.name]}
                          download
                          style={{ textDecoration: "none", color: "#7BD755" }}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src={pdfIcon} // Use an icon for PDFs
                            alt="pdf"
                            style={{
                              width: "50px",
                              height: "50px",
                              marginTop: "10px",
                            }}
                          />
                          <p style={{ fontSize: "14px" }}>Download PDF</p>
                        </a>
                      </div>
                    ) : (
                      <a
                        href={formData[field.name]}
                        download
                        style={{ textDecoration: "none", color: "#7BD755" }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src={formData[field.name]}
                          alt="uploaded"
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "cover",
                            marginTop: "10px",
                          }}
                        />
                      </a>
                    )}
                  </div>
                ) : (
                  <div style={{ marginTop: "10px" }}>
                    {formData[field.name].type === "application/pdf" ? ( // Check if it's a PDF
                      <a
                        href={URL.createObjectURL(formData[field.name])}
                        download
                        style={{ textDecoration: "none", color: "#7BD755" }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src={pdfIcon} // Use an icon for PDFs
                          alt="pdf"
                          style={{
                            width: "50px",
                            height: "50px",
                            marginTop: "10px",
                          }}
                        />
                        <p style={{ fontSize: "14px" }}>Download PDF</p>
                      </a>
                    ) : (
                      <a
                        href={URL.createObjectURL(formData[field.name])}
                        download
                        style={{ textDecoration: "none", color: "#7BD755" }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src={URL.createObjectURL(formData[field.name])}
                          alt="uploaded"
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "cover",
                            marginTop: "10px",
                          }}
                        />
                      </a>
                    )}
                  </div>
                )
              ) : (
                <div style={{ marginTop: "10px" }}>
                  <p style={{ fontSize: "15px", color: "#7BD755" }}>
                    No file uploaded
                  </p>
                </div>
              )}
              {validationErrors[field?.name] && (
                <div className="error-feedback">
                  {validationErrors[field?.name]}
                </div>
              )}
            </div>
          </>
        );

      case "productfile":
        return (
          <>
            <label style={{ paddingBottom: "10px", paddingTop: "10px" }}>
              {field.label}
              {field.required && <span className="required-asterisk">*</span>}
            </label>
            <div key={field.name} className={`form-group${additionalClass}`}>
              <div
                className="file-drop-area"
                onDrop={(e) => handleFileDrop(e, field.name)}
                onDragOver={handleDragOver}
              >
                <div className="customFileUpload">
                  <div className="custom-file-upload">
                    <input
                      type="file"
                      name={field.name}
                      id={field.name}
                      onChange={(e) =>
                        handleChange(
                          field.name,
                          e.target.files[0],
                          "file",
                          field?.allowedExtensions,
                        )
                      }
                      multiple={field.multiple || false}
                      className="file-input"
                      style={{ display: "none" }}
                    />
                    <label htmlFor={field.name} className="custom-file-label">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img src={uploadIcon} alt="upload" />
                        {fileNames[field.name] || (
                          <div>
                            <p style={{ fontSize: "15px" }}>
                              Drag your files here or{" "}
                              <span style={{ color: "#7BD755" }}>Browse</span>
                            </p>
                            <p style={{ fontSize: "14px", fontWeight: "300" }}>
                              (File Format -JPEG, JPG, PNG, PDF, Max limit 2 MB)
                            </p>
                          </div>
                        )}
                      </div>
                    </label>
                  </div>
                </div>
                {formData?.[field?.name] && (
                  <div className="d-flex justify-content-end">
                    <button
                      type="button"
                      className="btn btn-link p-0"
                      style={{ color: "#7BD755" }}
                      onClick={() => {
                        handleChange(field.name, null, "file");
                        document.getElementById(field.name).value = "";
                      }}
                    >
                      Clear
                    </button>
                  </div>
                )}
              </div>
              {validationErrors[field.name] && (
                <div className="invalid-feedback">
                  {validationErrors[field.name]}
                </div>
              )}

              {formData[field.name] ? (
                typeof formData[field.name] === "string" ? ( // Check if it's a URL
                  <div style={{ marginTop: "10px" }}>
                    {formData[field.name].endsWith(".pdf") ? ( // Check if file is a PDF
                      <div>
                        <a
                          href={formData[field.name]}
                          download
                          style={{ textDecoration: "none", color: "#7BD755" }}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src={pdfIcon} // Use an icon for PDFs
                            alt="pdf"
                            style={{
                              width: "50px",
                              height: "50px",
                              marginTop: "10px",
                            }}
                          />
                          <p style={{ fontSize: "14px" }}>Download PDF</p>
                        </a>
                      </div>
                    ) : (
                      <a
                        href={formData[field.name]}
                        download
                        style={{ textDecoration: "none", color: "#7BD755" }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src={formData[field.name]}
                          alt="uploaded"
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "cover",
                            marginTop: "10px",
                          }}
                        />
                      </a>
                    )}
                  </div>
                ) : (
                  <div style={{ marginTop: "10px" }}>
                    {formData[field.name].type === "application/pdf" ? ( // Check if it's a PDF
                      <a
                        href={URL.createObjectURL(formData[field.name])}
                        download
                        style={{ textDecoration: "none", color: "#7BD755" }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src={pdfIcon} // Use an icon for PDFs
                          alt="pdf"
                          style={{
                            width: "50px",
                            height: "50px",
                            marginTop: "10px",
                          }}
                        />
                        <p style={{ fontSize: "14px" }}>Download PDF</p>
                      </a>
                    ) : (
                      <a
                        href={URL.createObjectURL(formData[field.name])}
                        download
                        style={{ textDecoration: "none", color: "#7BD755" }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src={URL.createObjectURL(formData[field.name])}
                          alt="uploaded"
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "cover",
                            marginTop: "10px",
                          }}
                        />
                      </a>
                    )}
                  </div>
                )
              ) : (
                <div style={{ marginTop: "10px" }}>
                  <p style={{ fontSize: "15px", color: "#7BD755" }}>
                    No file uploaded
                  </p>
                </div>
              )}
            </div>
          </>
        );

      case "file":
        // console.log(fileNames[field.name], "file names");
        return (
          <>
            <label style={{ paddingBottom: "10px", paddingTop: "10px" }}>
              {field.label}
              {field.required && <span className="required-asterisk">*</span>}
            </label>
            <div key={field.name} className={`form-group${additionalClass}`}>
              <div
                className="file-drop-area"
                onDrop={(e) => handleFileDrop(e, field.name)}
                onDragOver={handleDragOver}
              >
                <div className="customFileUploadd">
                  <div className="custom-file-upload">
                    <input
                      type="file"
                      name={field.name}
                      id={field.name}
                      accept={acceptString}
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                          const fileName = file.name;
                          // Check for double extensions (more than one dot in filename)
                          if (fileName.split(".").length > 2) {
                            Swal.fire({
                              icon: "error",
                              title: "Invalid File Format",
                              text: "Double extensions are not allowed.",
                            });
                            setValidationErrors((prev) => ({
                              ...prev,
                              [field.name]:
                                "Double extensions are not allowed.",
                            }));
                            return;
                          }
                          // Clear any previous validation error for this field
                          setValidationErrors((prev) => {
                            const updated = { ...prev };
                            delete updated[field.name];
                            return updated;
                          });
                          // Proceed with handleChange
                          handleChange(
                            field.name,
                            file,
                            "file",
                            field?.allowedExtensions,
                          );
                        }
                      }}
                      multiple={field.multiple || false}
                      className="file-input"
                      style={{ display: "none" }}
                    />
                    <label htmlFor={field.name} className="custom-file-label">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img src={uploadIcon} alt="upload" />
                        {fileNames[field.name] &&
                        !validationErrors[field.name] ? (
                          <p style={{ fontSize: "14px", fontWeight: 500 }}>
                            {fileNames[field.name]}
                          </p>
                        ) : (
                          <div>
                            <p style={{ fontSize: "15px" }}>
                              Drag your files here or{" "}
                              <span style={{ color: "#7BD755" }}>Browse</span>
                            </p>
                            <p style={{ fontSize: "14px", fontWeight: "300" }}>
                              {fileHintText}
                            </p>
                          </div>
                        )}
                      </div>
                    </label>
                  </div>
                </div>
              </div>
              {formData?.[field?.name] && (
                <div
                  style={{ width: "100%" }}
                  className="d-flex justify-content-end"
                >
                  <button
                    type="button"
                    className="btn btn-link p-0"
                    style={{ color: "#7BD755" }}
                    onClick={() => {
                      handleChange(field.name, null, "file");
                      setFileNames((prev) => {
                        const updated = { ...prev };
                        delete updated[field.name];
                        return updated;
                      });
                      document.getElementById(field.name).value = "";
                    }}
                  >
                    Clear
                  </button>
                </div>
              )}

              {renderSingleFilePreview(formData[field.name])}
              {validationErrors[field?.name] && (
                <div className="error-feedback">
                  {validationErrors[field?.name]}
                </div>
              )}
            </div>
          </>
        );

      case "dealerfile":
        return (
          <>
            <label style={{ paddingBottom: "4px", paddingTop: "4px" }}>
              {field.label}
              {field.required && <span className="required-asterisk">*</span>}
            </label>
            <div key={field.name} className={`form-group${additionalClass}`}>
              <div
                className="file-drop-area"
                onDrop={(e) => handleFileDrop(e, field.name)}
                onDragOver={handleDragOver}
              >
                <div
                  style={{ height: "3.5rem", borderRadius: "10px" }}
                  className="customFileUpload"
                >
                  <div className="custom-file-upload">
                    <input
                      type="file"
                      name={field.name}
                      id={field.name}
                      onChange={(e) =>
                        handleChange(field.name, e.target.files[0])
                      }
                      multiple={field.multiple || false}
                      className="file-input"
                      style={{ display: "none" }}
                    />
                    <label htmlFor={field.name} className="custom-file-label">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "flex-start",
                          justifyContent: "center",
                          paddingTop: "1rem",
                        }}
                      >
                        <img
                          src={uploadIcon}
                          alt="upload"
                          style={{
                            height: "2.2rem",
                            width: "2.2rem",
                            marginTop: "10px",
                          }}
                        />
                        {fileNames[field.name] || (
                          <div>
                            <p
                              style={{
                                fontSize: "15px",
                                paddingTop: "10px",
                                paddingLeft: "10px",
                              }}
                            >
                              Drag your files here or{" "}
                              <span style={{ color: "#7BD755" }}>Browse</span>
                            </p>
                            <p style={{ fontSize: "14px", fontWeight: "300" }}>
                              {/* (File Format - JPG, PNG, PDF, CSV) */}
                            </p>
                          </div>
                        )}
                      </div>
                    </label>
                  </div>
                </div>
              </div>
              {validationErrors[field.name] && (
                <div className="invalid-feedback">
                  {validationErrors[field.name]}
                </div>
              )}

              {formData[field.name] ? (
                typeof formData[field.name] === "string" ? ( // Check if it's a URL
                  <div style={{ marginTop: "10px" }}>
                    {formData[field.name].endsWith(".pdf") ? ( // Check if file is a PDF
                      <div>
                        <a
                          href={formData[field.name]}
                          download
                          style={{ textDecoration: "none", color: "#7BD755" }}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src={pdfIcon} // Use an icon for PDFs
                            alt="pdf"
                            style={{
                              width: "50px",
                              height: "50px",
                              marginTop: "10px",
                            }}
                          />
                          <p style={{ fontSize: "14px" }}>Download PDF</p>
                        </a>
                      </div>
                    ) : (
                      <a
                        href={formData[field.name]}
                        download
                        style={{ textDecoration: "none", color: "#7BD755" }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src={formData[field.name]}
                          alt="uploaded"
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "cover",
                            marginTop: "10px",
                          }}
                        />
                      </a>
                    )}
                  </div>
                ) : (
                  <div style={{ marginTop: "10px" }}>
                    {formData[field.name].type === "application/pdf" ? ( // Check if it's a PDF
                      <a
                        href={URL.createObjectURL(formData[field.name])}
                        download
                        style={{ textDecoration: "none", color: "#7BD755" }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src={pdfIcon} // Use an icon for PDFs
                          alt="pdf"
                          style={{
                            width: "50px",
                            height: "50px",
                            marginTop: "10px",
                          }}
                        />
                        <p style={{ fontSize: "14px" }}>Download PDF</p>
                      </a>
                    ) : (
                      <a
                        href={URL.createObjectURL(formData[field.name])}
                        download
                        style={{ textDecoration: "none", color: "#7BD755" }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src={URL.createObjectURL(formData[field.name])}
                          alt="uploaded"
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "cover",
                            marginTop: "10px",
                          }}
                        />
                      </a>
                    )}
                  </div>
                )
              ) : (
                <div style={{ marginTop: "24px" }}>
                  <p style={{ fontSize: "15px", color: "#7BD755" }}>
                    No file uploaded
                  </p>
                </div>
              )}
            </div>
          </>
        );

      // image upload

      case "uploadimage":
        return (
          <>
            <label style={{ paddingBottom: "10px", paddingTop: "10px" }}>
              {field.label} <span style={{ color: "red" }}>*</span>
            </label>
            <div key={field.name} className="form-control">
              {/* Drag-and-Drop Area */}
              <div
                className="file-drop-area custom-file-upload"
                onDrop={(e) => handleFileDrop(e, field.name)}
                onDragOver={handleDragOver}
              >
                {/* Hidden Input for File */}
                <input
                  type="file"
                  name={field.name}
                  id={field.name}
                  accept="image/png, image/jpeg"
                  onChange={(e) => handleChange(field.name, e.target.files[0])}
                  className="form-control"
                  style={{ display: "none" }}
                />
                <label htmlFor={field.name} className="custom-file-label">
                  {/* Placeholder or Preview */}
                  <span style={{ color: "#6c757d" }}>
                    {fileNames[field.name] || "Upload Image"}
                  </span>
                  <img
                    src={uploadIcon} // Replace with your upload icon path
                    alt="upload"
                    style={{ width: "20px", height: "20px" }}
                  />
                </label>
              </div>

              {/* Error Message */}
              {validationErrors[field.name] && (
                <div
                  className="invalid-feedback"
                  style={{ color: "red", marginTop: "5px" }}
                >
                  {validationErrors[field.name]}
                </div>
              )}

              {/* Image Preview */}
              {formData[field.name] && (
                <div style={{ marginTop: "10px", textAlign: "center" }}>
                  <img
                    src={
                      typeof formData[field.name] === "string"
                        ? formData[field.name]
                        : URL.createObjectURL(formData[field.name])
                    }
                    alt="Preview"
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "cover",
                      borderRadius: "8px",
                      border: "1px solid #ddd",
                    }}
                  />
                </div>
              )}
            </div>
          </>
        );

      case "agentfile":
        return (
          <>
            <label style={{ paddingBottom: "10px", paddingTop: "10px" }}>
              {field.label}
            </label>
            <div key={field.name} className={`form-group${additionalClass}`}>
              <div
                className="file-drop-area"
                onDrop={(e) => handleFileDrop(e, field.name)}
                onDragOver={handleDragOver}
              >
                <div className="customFileUpload">
                  <div className="custom-file-upload">
                    <input
                      type="file"
                      name={field.name}
                      id={field.name}
                      onChange={(e) =>
                        handleChange(field.name, e.target.files[0])
                      }
                      className="file-input"
                      style={{ display: "none" }}
                    />
                    <label htmlFor={field.name} className="custom-file-label">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img src={uploadIcon} />
                        {fileNames[field.name] || (
                          <div>
                            <p style={{ fontSize: "15px" }}>
                              Drag your files here or{" "}
                              <span style={{ color: "#7BD755" }}>Browse</span>
                            </p>
                            <p style={{ fontSize: "14px", fontWeight: "300" }}>
                              (File Format - JPG, PNG)
                            </p>
                          </div>
                        )}
                      </div>
                    </label>
                  </div>
                </div>
              </div>
              {validationErrors[field.name] && (
                <div className="error-feedback">
                  {validationErrors[field.name]}
                </div>
              )}

              {formData[field.name] ? (
                <div style={{ marginTop: "10px" }}>
                  <p style={{ fontSize: "15px", color: "#7BD755" }}>
                    {formData[field.name].name}
                  </p>
                </div>
              ) : null}
            </div>
          </>
        );

      case "button":
        return (
          <div className=" mt-1 mb-2">
            <label>{""}</label>
            <div className="downloadiconwrapper " onClick={buttonOnclick}>
              <label>{field.label}</label>
            </div>
          </div>
        );

      case "downloadbutton":
        return (
          <div
            style={{ marginTop: "35px" }}
            className="downloadiconwrapperr "
            onClick={handledownload}
          >
            <img className="downloadIcon" src={downloadIcon} />
            <a className="downloadHeading">Download</a>
          </div>
        );

      case "complainbutton":
        return (
          <>
            <div className="formbutton " onClick={addComplainHandler}>
              <img src={addcomplaiIcon} />
              <button className="complainbutton">Add Complain</button>
            </div>
            <span className="addcomplaininfo">
              Add atleast one complaint to proceed
            </span>
          </>
        );

      case "title":
        return (
          <>
            <div className="coheading">
              <span>Add Vehicle / Spare Part</span>
            </div>
          </>
        );

      case "date":
        const openDatePicker = (fieldName) => {
          if (datePickerRefs.current[fieldName]) {
            datePickerRefs.current[fieldName].setFocus();
          }
        };

        return (
          <div key={field?.name} className="mt-2 mb-2">
            <label>
              {field.label}{" "}
              {field.required && <span className="required-asterisk">*</span>}
            </label>
            <div className="input-group">
              <DatePicker
                ref={(ref) => (datePickerRefs.current[field.name] = ref)}
                placeholderText="DD/MM/YYYY"
                disabled={field?.disabled ? true : false}
                selected={
                  formData[field?.name] ? new Date(formData[field.name]) : null
                }
                onChange={(date) => handleChange(field.name, date, "date")}
                // dateFormat="yyyy-MM-dd"
                dateFormat="dd/MM/yyyy"
                className={`form-control ${
                  validationErrors[field.name] && "is-invalid"
                }`}
                minDate={field?.minDate}
                maxDate={field?.maxDate}
                showMonthDropdown // Show month dropdown
                showYearDropdown // Show year dropdown
                dropdownMode="select" // Makes the dropdown in "select" mode
              />
              <span
                className="input-group-text"
                onClick={() => openDatePicker(field.name)}
                style={{ cursor: "pointer" }}
              >
                <FaCalendarAlt />
              </span>
            </div>
            {validationErrors[field.name] && (
              <div className="error-feedback">
                {validationErrors[field.name]}
              </div>
            )}
          </div>
        );

      case "warrantydate":
        const openWarrentyDatePicker = (fieldName) => {
          if (datePickerRefs.current[fieldName]) {
            datePickerRefs.current[fieldName].setFocus();
          }
        };

        return (
          <div key={field?.name} className="mt-2 mb-2">
            <label>
              {field.label}{" "}
              {field.required && <span className="required-asterisk">*</span>}
            </label>
            <div className="input-group">
              <DatePicker
                ref={(ref) => (datePickerRefs.current[field.name] = ref)}
                placeholderText="DD/MM/YYYY"
                disabled={field?.disabled ? true : false}
                selected={
                  formData[field?.name] ? new Date(formData[field.name]) : null
                }
                onChange={(date) => handleChange(field.name, date, "date")}
                dateFormat="dd/MM/yyyy"
                className={`form-control ${
                  validationErrors[field.name] && "is-invalid"
                }`}
                minDate={new Date()} // Minimum date is today
                maxDate={
                  new Date(new Date().setFullYear(new Date().getFullYear() + 7))
                } // Maximum date is 7 years from today
                showMonthDropdown // Show month dropdown
                showYearDropdown // Show year dropdown
                dropdownMode="select" // Makes the dropdown in "select" mode
                renderCustomHeader={({ date, changeYear }) => {
                  const startYear = new Date().getFullYear();
                  const endYear = startYear + 7;

                  return (
                    <div>
                      <select
                        value={date.getFullYear()}
                        onChange={({ target: { value } }) => changeYear(value)}
                      >
                        {Array.from(
                          { length: endYear - startYear + 1 },
                          (_, i) => startYear + i,
                        ).map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>
                    </div>
                  );
                }}
              />

              <span
                className="input-group-text"
                onClick={() => openWarrentyDatePicker(field.name)}
                style={{ cursor: "pointer" }}
              >
                <FaCalendarAlt />
              </span>
            </div>
            {validationErrors[field.name] && (
              <div className="error-feedback">
                {validationErrors[field.name]}
              </div>
            )}
          </div>
        );
      case "datetime":
        return (
          <div key={field.name} className="mt-2 mb-2">
            <label>
              {field.label}
              {field.required && <span className="required-asterisk">*</span>}
            </label>
            <div className="input-group">
              <DatePicker
                ref={datePickerRefs}
                disabled={field?.disabled ? true : false}
                selected={
                  formData[field.name] ? new Date(formData[field.name]) : null
                }
                onChange={(date) => handleChange(field.name, date, "datetime")}
                showTimeSelect
                dateFormat="dd/MM/yyyy"
                placeholderText="DD/MM/YYYY"
                maxDate={field.maxDate}
                minDate={field.minDate}
                className={`form-control ${
                  validationErrors[field.name] && "is-invalid"
                }`}
              />
              <div className="input-group-append">
                <span
                  className="input-group-text"
                  onClick={() => datePickerRefs.current.setFocus()}
                >
                  <FaCalendarAlt />
                </span>
              </div>
            </div>
            {validationErrors[field.name] && (
              <div className="error-feedback">
                {validationErrors[field.name]}
              </div>
            )}
          </div>
        );
      case "toggle":
        return (
          <div
            key={field?.name}
            className={`${additionalClass} mt-3 mb-3 togglecontainer`}
          >
            <Switch
              checked={formData[field?.name] || false}
              onChange={(checked) =>
                handleChange(field?.name, checked, "toggle")
              }
              onColor="#7BD755"
              onHandleColor="#7BD755"
              handleDiameter={30}
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              height={20}
              width={48}
              className="react-switch"
              id="material-switch"
              disabled={field?.disabled ? true : false}
            />
            <label className="mt-3 mb-3">{field.label}</label>
            {validationErrors[field?.name] && (
              <div className="invalid-feedback">
                {validationErrors[field?.name]}
              </div>
            )}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="row">
      {formConfig?.map((field) => (
        <div key={field?.name} className={`${field.gridClass}`}>
          {(showParentDesignation || field?.isVisible !== false) &&
            renderField(field)}
        </div>
      ))}
    </div>
  );
};

export default DynamicForm;
